import React from "react";
import AppMessageView from "./AppMessageView";
import { useAppSelector } from "../utils/hooks";

const AppInfoView = () => {
  const { error, message } = useAppSelector(state => state.common);

  const showMessage = () => {
    return <AppMessageView variant="success" message={message.toString()} />;
  };

  const showError = () => {
    return <AppMessageView variant="error" message={error.toString()} />;
  };

  return (
    <>
      {message && showMessage()}
      {error && showError()}
    </>
  );
};

export default AppInfoView;
